export default __webpack_public_path__ + "static/media/card-pick.d26894ed.mp3";